/* The Red — gallery lightbox: click para ver original, flechas/teclado/swipe para navegar */
(function () {
  'use strict';
  function init() {
    var grid = document.querySelector('[data-gallery]');
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('.exp-gallery__item'));
    if (!items.length) return;
    var srcs = items.map(function (b) { return b.getAttribute('data-full'); });
    var current = 0;

    // overlay
    var ov = document.createElement('div');
    ov.className = 'trlb';
    ov.setAttribute('aria-hidden', 'true');
    ov.innerHTML =
      '<button class="trlb__close" aria-label="Close">&times;</button>' +
      '<button class="trlb__nav trlb__prev" aria-label="Previous">&#8249;</button>' +
      '<figure class="trlb__stage"><img class="trlb__img" alt=""></figure>' +
      '<button class="trlb__nav trlb__next" aria-label="Next">&#8250;</button>' +
      '<div class="trlb__count"></div>';
    document.body.appendChild(ov);
    var img = ov.querySelector('.trlb__img');
    var count = ov.querySelector('.trlb__count');

    function show(i) {
      current = (i + srcs.length) % srcs.length;
      img.src = srcs[current];
      count.textContent = (current + 1) + ' / ' + srcs.length;
    }
    function open(i) {
      show(i);
      ov.classList.add('is-open');
      ov.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      ov.classList.remove('is-open');
      ov.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    items.forEach(function (b, i) { b.addEventListener('click', function () { open(i); }); });
    ov.querySelector('.trlb__close').addEventListener('click', close);
    ov.querySelector('.trlb__prev').addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
    ov.querySelector('.trlb__next').addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });
    ov.addEventListener('click', function (e) { if (e.target === ov || e.target.classList.contains('trlb__stage')) close(); });
    document.addEventListener('keydown', function (e) {
      if (!ov.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });
    // swipe
    var x0 = null;
    ov.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    ov.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
